import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetCompanyLogo = (companyId: string, enabled = true) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetLogoQuery({
    request: { companyId },
    options: { enabled: !!companyId && enabled },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  return {
    logoUrl: data?.url,
    isLoading,
    isError,
  };
};
